import { Route } from '@angular/router';

export const utilitiesRoute: Route = {
  path: 'utilities',
  data: {
    title: 'Utility'
  },
  loadChildren: () => import('../spread/utility.module').then(m => m.UtilityModule)
};
